import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Stack, Typography } from "@mui/material";
import Button from "@components/Button/Button";
import LogoMarhub from "@components/LogoMarhub/LogoMarhub";
import { paths } from "@utils/navigation";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const TEST_ID_BASE = "vendor-license-confirmation";
const LANG_BASE = "licensing";

const VendorLicenseRequestConfirmationPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  const goToPofWebsite = () => {
    window.location.assign("https://fujairahport.ae/");
  };

  return (
    <Box dir={dir} data-testid={`${TEST_ID_BASE}-page`} className="min-h-screen flex flex-col">
      <Box className="flex justify-center pt-8 sm:pt-12">
        <LogoMarhub height={60} to={paths.vendorLicenseRequest} />
      </Box>

      <Box className="flex-1 flex items-center justify-center px-6 sm:px-8 pb-12 sm:pb-16">
        <Stack alignItems="center" className="text-center w-full" style={{ maxWidth: 560 }}>
          <CheckCircleIcon color="success" className="mb-6" style={{ fontSize: 72 }} />

          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, fontSize: 32 }}>
            {t(`${LANG_BASE}.vendor-license-request-confirmation-thank-you`)}
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 500, fontSize: 20, mb: 1, mt: 2 }}>
            {t(`${LANG_BASE}.vendor-license-request-confirmation-submitted`)}
          </Typography>

          <Typography
            variant="caption"
            sx={{
              color: "text.primary",
              lineHeight: "20px",
              fontWeight: 400,
              fontSize: 14,
              mb: 4,
            }}
          >
            {t(`${LANG_BASE}.vendor-license-request-confirmation-email-sent`)}
          </Typography>

          <Stack alignItems="center" spacing={2} sx={{ mt: 6 }}>
            <Button
              testId={`${TEST_ID_BASE}-request-new`}
              label={t(`${LANG_BASE}.vendor-license-request-confirmation-request-new`)}
              variant="contained"
              type="button"
              onClick={() => navigate(paths.vendorLicenseRequest)}
              sx={{ minWidth: 220, height: 40, minHeight: 40, textTransform: "none" }}
            />

            <Button
              testId={`${TEST_ID_BASE}-go-back`}
              label={t(`${LANG_BASE}.vendor-license-request-confirmation-go-to-pof`)}
              variant="text"
              type="button"
              onClick={goToPofWebsite}
              sx={{ minWidth: 220, height: 40, minHeight: 40, textTransform: "none" }}
            />
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default VendorLicenseRequestConfirmationPage;
